// AI Generated Pipe
import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';

@Pipe({
    name: 'uptimeIncidientTime',
    standalone: false,
})
export class UptimeIncidientTimePipe implements PipeTransform {
    dateTimeService = inject(DateTimeService);

    transform (date: any): string {
        if (!date) {
            return '';
        }

        const localeData = this.dateTimeService.localeData();
        const formats = {
            sameElse: localeData.longDateFormat('L') + ' ' + localeData.longDateFormat('LT'),
        };

        return this.dateTimeService.calendar(date, new Date(), formats);
    }
}
